var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useTranslateLabel } from 'react-admin';
import { Templates } from '@rjsf/mui';
export var BaseInputTemplate = function (props) {
    var name = props.name, label = props.label;
    var translateLabel = useTranslateLabel();
    var translatedLabel = translateLabel({
        source: name,
        label: label === name ? undefined : label,
    });
    return React.createElement(Templates.BaseInputTemplate, __assign({}, props, { label: translatedLabel }));
};
